import { IntlMessageId } from "src/assets/localization/types";
import { StringIndexedDictionary } from "src/globalTypes";

export enum DelimiterPatternIds {
  EMPTY = 1,
  HORIZONTAL_LINE = 2,
  VERTICAL_LINE = 3,
  HORIZONTAL_DOTTED_LINE = 4,
  VERTICAL_DOTTED_LINE = 5,
}

export enum DelimiterPositionEnum {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export enum DelimiterStyleEnum {
  EMPTY = "empty",
  LINE = "line",
  DOTTED_LINE = "dottedLine",
}

export type DelimiterPattern<
  Id extends DelimiterPatternIds = DelimiterPatternIds
> = {
  id: Id;
  position: DelimiterPositionEnum;
  pattern: DelimiterStyleEnum;
  intlId: IntlMessageId;
};

export type DelimiterPatterns = {
  [DelimiterPatternId in DelimiterPatternIds]: DelimiterPattern<DelimiterPatternId>;
};

export const DELIMITER_PATTERNS: DelimiterPatterns = {
  [DelimiterPatternIds.EMPTY]: {
    id: DelimiterPatternIds.EMPTY,
    position: DelimiterPositionEnum.HORIZONTAL,
    pattern: DelimiterStyleEnum.EMPTY,
    intlId: "template_builder.column_position_editor.delimiter.empty",
  },
  [DelimiterPatternIds.HORIZONTAL_LINE]: {
    id: DelimiterPatternIds.HORIZONTAL_LINE,
    position: DelimiterPositionEnum.HORIZONTAL,
    pattern: DelimiterStyleEnum.LINE,
    intlId: "template_builder.column_position_editor.delimiter.line_horizontal",
  },
  [DelimiterPatternIds.HORIZONTAL_DOTTED_LINE]: {
    id: DelimiterPatternIds.HORIZONTAL_DOTTED_LINE,
    position: DelimiterPositionEnum.HORIZONTAL,
    pattern: DelimiterStyleEnum.DOTTED_LINE,
    intlId:
      "template_builder.column_position_editor.delimiter.dotted_line_horizontal",
  },
  [DelimiterPatternIds.VERTICAL_LINE]: {
    id: DelimiterPatternIds.VERTICAL_LINE,
    position: DelimiterPositionEnum.VERTICAL,
    pattern: DelimiterStyleEnum.LINE,
    intlId: "template_builder.column_position_editor.delimiter.line_vertical",
  },
  [DelimiterPatternIds.VERTICAL_DOTTED_LINE]: {
    id: DelimiterPatternIds.VERTICAL_DOTTED_LINE,
    position: DelimiterPositionEnum.VERTICAL,
    pattern: DelimiterStyleEnum.DOTTED_LINE,
    intlId:
      "template_builder.column_position_editor.delimiter.dotted_line_vertical",
  },
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface DelimiterFormat {
  // empty for now, might add new stuff in future
}

export interface Delimiter {
  delimiterId: string;
  delimiterPatternId: DelimiterPatternIds;
  format: DelimiterFormat;
}

export type Delimiters = StringIndexedDictionary<Delimiter>;
